// ── Global: subcategories nav ─────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.collection-subcategories__link');
    if (!link) return;
    var nav = link.closest('.collection-subcategories__nav');
    if (!nav) return;
    nav.querySelectorAll('.collection-subcategories__link').forEach(function (el) {
      el.classList.remove('is-active', 'body-l-bold');
      el.classList.add('body-l-regular');
    });
    link.classList.remove('body-l-regular');
    link.classList.add('is-active', 'body-l-bold');
  });
}());

// ── Global: abrir modal de tallas desde cualquier product card ───────────
(function () {
  if (window.__collectionSizeModalInit) return;
  window.__collectionSizeModalInit = true;

  document.querySelectorAll('.product-size-modal:not([data-hoisted]), .product-color-modal:not([data-hoisted])').forEach(function (modal) {
    modal.dataset.hoisted = '1';
    document.body.appendChild(modal);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cta-add-resp');
    if (!btn) return;
    e.preventDefault();
    var modal = document.getElementById(btn.dataset.opensModal);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product-size-modal__close') &&
        !e.target.classList.contains('product-size-modal__backdrop')) return;
    var modal = e.target.closest('.product-size-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });
}());

// ── Global: cart add from product card size pills ────────────────────────
(function () {
  if (window.__collectionCardSizeAddInit) return;
  window.__collectionCardSizeAddInit = true;

  function updateCollectionCartCounters() {
    return fetch((window.routes?.cart_url || '/cart') + '.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-badge').forEach(function (counter) {
          counter.textContent = cart.item_count > 99 ? '+' : (cart.item_count || '');
          counter.classList.toggle('hidden', cart.item_count === 0);
        });
        document.querySelectorAll('.cart-drawer__title-counter').forEach(function (counter) {
          counter.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function showCollectionCartPopup(lineItem) {
    var cartPopupEl = document.querySelector('cart-popup');
    if (!cartPopupEl) return;

    if (typeof cartPopupEl.show === 'function') {
      try {
        cartPopupEl.show(lineItem);
        cartPopupEl.setAttribute('open', '');
        return;
      } catch (err) {
        console.error('Cart popup could not be shown:', err);
      }
    }

    var productImage = cartPopupEl.querySelector('[data-popup-image]');
    var productImageWrapper = cartPopupEl.querySelector('[data-popup-image-wrapper]');
    var productTitle = cartPopupEl.querySelector('[data-popup-title]');
    var productVariant = cartPopupEl.querySelector('[data-popup-variant]');
    var productPrice = cartPopupEl.querySelector('[data-popup-price]');
    var productComparePrice = cartPopupEl.querySelector('[data-popup-compare-price]');
    var cartCountEl = cartPopupEl.querySelector('[data-popup-cart-count]');

    if (productImage && lineItem.image) {
      productImage.src = lineItem.image;
      productImage.alt = lineItem.product_title || '';
      productImageWrapper?.classList.remove('hidden');
    } else {
      productImageWrapper?.classList.add('hidden');
    }

    if (productTitle) productTitle.textContent = lineItem.product_title || lineItem.title || '';
    if (productVariant) {
      productVariant.textContent = lineItem.variant_title || '';
      productVariant.style.display = lineItem.variant_title ? '' : 'none';
    }
    if (productPrice) productPrice.textContent = lineItem.final_price ? (lineItem.final_price / 100).toFixed(2).replace('.', ',') + '€' : '';
    if (productComparePrice) productComparePrice.setAttribute('hidden', '');
    if (cartCountEl) {
      fetch((window.routes?.cart_url || '/cart') + '.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) { cartCountEl.textContent = '(' + (cart.item_count || 0) + ')'; })
        .catch(function () {});
    }

    cartPopupEl.setAttribute('open', '');
  }

  function getCollectionCartAddUrl() {
    var cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    return cartAddUrl.endsWith('.js') ? cartAddUrl : cartAddUrl + '.js';
  }

  function findCardFromPill(pill) {
    var card = pill.closest('product-card');
    if (card) return card;

    var modal = pill.closest('.product-size-modal[id]');
    if (!modal) return null;

    card = document.querySelector('product-card[data-modal-id="' + modal.id + '"]');
    if (card) return card;

    var ctaBtn = document.querySelector('.cta-add-resp[data-opens-modal="' + modal.id + '"]');
    return ctaBtn ? ctaBtn.closest('product-card') : null;
  }

  document.addEventListener('click', function (e) {
    if (e.__productCardSizeAddHandled) return;
    var pill = e.target.closest('.product-card__size-pill');
    if (!pill) return;

    var sizesDiv = pill.closest('.product-card__sizes-hover') || pill.closest('.product-size-modal__sizes');
    if (!sizesDiv) return;

    if (pill.classList.contains('loading')) return;
    e.__productCardSizeAddHandled = true;
    e.preventDefault();
    e.stopImmediatePropagation();

    var sizeOptionPos = parseInt(sizesDiv.dataset.sizeOptionPos);
    var sizeValue = pill.dataset.value;
    var card = findCardFromPill(pill);
    if (!card || !sizeOptionPos || !sizeValue) return;

    var colorFieldset = card.querySelector('.js-color-fieldset');
    var selectedColor = null;
    var colorOptionPos = null;
    if (colorFieldset) {
      colorOptionPos = parseInt(colorFieldset.dataset.optionPos);
      var checkedRadio = colorFieldset.querySelector('.variant-option-radio-input:checked');
      if (checkedRadio) selectedColor = checkedRadio.value;
    }

    var variantsScript = card.querySelector('[data-product-variants-json]');
    if (!variantsScript) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (err) { return; }

    var targetVariant = variants.find(function (variant) {
      if (variant['option' + sizeOptionPos] !== sizeValue) return false;
      if (selectedColor && colorOptionPos) return variant['option' + colorOptionPos] === selectedColor;
      return true;
    });

    if (!targetVariant || !targetVariant.available) {
      pill.classList.add('unavailable');
      setTimeout(function () { pill.classList.remove('unavailable'); }, 1500);
      return;
    }

    sizesDiv.querySelectorAll('.product-card__size-pill').forEach(function (sizePill) {
      sizePill.classList.remove('selected', 'added');
    });
    pill.classList.add('selected', 'loading');
    window.LolaCartPopupInteraction?.lock();
    var cartPayload = { id: targetVariant.id, quantity: 1 };
    var selectedColorLabel = card.dataset.currentColor || '';
    if (selectedColorLabel) {
      cartPayload.properties = { _color: selectedColorLabel };
    }

    window.LolaCartGift.request(getCollectionCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cartPayload)
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        pill.classList.remove('loading');
        if (data.status || data.errors) {
          window.LolaCartPopupInteraction?.unlock();
          window.LolaCartError?.show(data);
          return;
        }

        pill.classList.add('added');
        showCollectionCartPopup(data);
        updateCollectionCartCounters().catch(function () {
          if (typeof updateCartCounters === 'function') updateCartCounters();
        });

        var openModal = pill.closest('.product-size-modal.is-open');
        if (openModal) {
          openModal.classList.remove('is-open');
          openModal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
        setTimeout(function () { pill.classList.remove('added'); }, 2000);
      })
      .catch(function (err) {
        window.LolaCartPopupInteraction?.unlock();
        window.LolaCartError?.show();
        console.error('Collection card add-to-cart request failed:', err);
        pill.classList.remove('loading');
      });
  });
}());

// ── Global: notify modal ──────────────────────────────────────────────────
(function () {
  if (window.__notifyAvisoInit) return;
  window.__notifyAvisoInit = true;

  var modal = document.getElementById('notify-aviso-modal');
  if (!modal) return;

  function openNotifyModal(productId, size, color, productHandle) {
    var pidInput      = modal.querySelector('#notify-product-id');
    var handleInput   = modal.querySelector('#notify-product-handle');
    var sizeInput     = modal.querySelector('#notify-size');
    var colorInput    = modal.querySelector('#notify-color');
    if (pidInput)    pidInput.value    = productId     || '';
    if (handleInput) handleInput.value = productHandle || '';
    if (sizeInput)   sizeInput.value   = size          || '';
    if (colorInput)  colorInput.value  = color         || '';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var emailInput = modal.querySelector('#notify-email');
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 350);
  }

  function closeNotifyModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function closeOpenModals() {
    var sizeModal = document.querySelector('.product-size-modal.is-open');
    if (sizeModal) {
      sizeModal.classList.remove('is-open');
      sizeModal.setAttribute('aria-hidden', 'true');
    }
    var colorModal = document.querySelector('.product-color-modal.is-open');
    if (colorModal) {
      colorModal.classList.remove('is-open');
      colorModal.setAttribute('aria-hidden', 'true');
    }
  }

  // Abrir al clicar en cualquier "Recibir aviso"
  document.addEventListener('click', function (e) {
    // Hover desktop pill
    var hoverNotify = e.target.closest('.product-card__hover-size-notify');
    if (hoverNotify) {
      e.preventDefault();
      var sizeItem    = hoverNotify.closest('.product-card__hover-size-item');
      var sizePill    = sizeItem ? sizeItem.querySelector('.product-card__size-pill') : null;
      var size        = sizePill ? sizePill.dataset.value : '';
      var card        = hoverNotify.closest('product-card');
      var colorRadio  = card ? card.querySelector('.js-color-fieldset .variant-option-radio-input:checked') : null;
      var color       = colorRadio ? colorRadio.value : '';
      var productId   = '';
      var productHandle = '';
      if (card) {
        var modalId = card.dataset.modalId || '';
        var sizeModal = document.getElementById(modalId) || card.querySelector('.product-size-modal[id]');
        if (sizeModal) {
          var parts = sizeModal.id.split('-');
          productId = sizeModal.dataset.productId || parts[parts.length - 1];
          productHandle = sizeModal.dataset.productHandle || '';
        }
      }
      closeOpenModals();
      openNotifyModal(productId, size, color, productHandle);
      return;
    }
    // Modal de tallas: hint de unavailable
    var sizeHint = e.target.closest('.product-size-modal__size-hint:not(.product-size-modal__size-hint--low)');
    if (sizeHint) {
      e.preventDefault();
      var sizeRow    = sizeHint.closest('.product-size-modal__size-row');
      var size       = sizeRow ? sizeRow.dataset.valueSize : '';
      var sizesDiv   = sizeHint.closest('.product-size-modal__sizes');
      var color      = sizesDiv ? sizesDiv.dataset.activeColor : '';
      var sizeModal  = sizeHint.closest('.product-size-modal[id]');
      var productId  = '';
      var productHandle = '';
      if (sizeModal) {
        var parts = sizeModal.id.split('-');
        productId = sizeModal.dataset.productId || parts[parts.length - 1];
        productHandle = sizeModal.dataset.productHandle || '';
      }
      closeOpenModals();
      openNotifyModal(productId, size, color, productHandle);
      return;
    }
  });

  // Cerrar
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-notify-close]')) closeNotifyModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeNotifyModal();
  });

  // Submit: validar email, producto y stock de variante
  modal.addEventListener('click', function (e) {
    var btn = e.target.closest('.notify-modal__submit');
    if (!btn) return;
    e.preventDefault();

    var emailInput    = modal.querySelector('#notify-email');
    var productId     = modal.querySelector('#notify-product-id').value.trim();
    var productHandle = modal.querySelector('#notify-product-handle').value.trim();
    var size          = modal.querySelector('#notify-size').value.trim();
    var color         = modal.querySelector('#notify-color').value.trim();
    var email         = emailInput ? emailInput.value.trim() : '';

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      emailInput && emailInput.focus();
      emailInput && (emailInput.style.borderBottomColor = '#CD2A1B');
      modal.querySelector('[data-notify-error]')?.removeAttribute('hidden');
      return;
    }
    emailInput && (emailInput.style.borderBottomColor = '');
    modal.querySelector('[data-notify-error]')?.setAttribute('hidden', '');

    if (!productHandle) {
      console.warn('[Aviso] No se encontró product handle');
      return;
    }

    fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        if (!product || !product.variants) {
          console.warn('[Aviso] Producto no encontrado — handle:', productHandle);
          return;
        }

        var matchingVariant = product.variants.find(function (v) {
          var hasColor = !color || v.options.some(function (o) { return o === color; });
          var hasSize  = !size  || v.options.some(function (o) { return o === size;  });
          return hasColor && hasSize;
        });

        if (!matchingVariant) {
          console.warn('[Aviso] No se encontró variante — handle:', productHandle, '| color:', color, '| talla:', size);
          return;
        }

        if (matchingVariant.available) {
          console.warn('[Aviso] Variante con stock — handle:', productHandle, '| color:', color, '| talla:', size);
          return;
        }

        console.log('[Aviso] Éxito — email:', email, '| handle:', productHandle, '| producto:', productId, '| color:', color, '| talla:', size);
        closeNotifyModal();
        var toast = document.getElementById('notify-toast');
        if (toast) {
          toast.classList.add('is-visible');
          setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
        }
      })
      .catch(function (err) {
        console.warn('[Aviso] Error al verificar producto — handle:', productHandle, err);
      });
  });
}());

// ── Per-section init ──────────────────────────────────────────────────────
function initCollectionSection(sectionEl) {
  if (sectionEl.dataset.collectionInitialized === 'true') return;
  sectionEl.dataset.collectionInitialized = 'true';

  var sectionId  = sectionEl.id.replace('shopify-section-', '');
  var grid = sectionEl.querySelector('#product-grid');
  if (!grid) return;

  var storageKey = 'collection-view-' + sectionId;
  var savedView = localStorage.getItem(storageKey) || 'small';
  if (savedView !== 'small' && savedView !== 'big') savedView = 'small';

  function updateProductCardImageSizes(view) {
    var sizes = view === 'big'
      ? '(min-width: 1024px) 50vw, 50vw'
      : '(min-width: 1440px) 25vw, (min-width: 1024px) 33vw, 50vw';

    grid.querySelectorAll('product-card .product-card__media img').forEach(function (img) {
      img.setAttribute('sizes', sizes);
    });
  }

  function applyCollectionView(view) {
    grid.classList.remove('collection__grid--small', 'collection__grid--big');
    grid.classList.add('collection__grid--' + view);
    grid.dataset.view = view;
    grid.dataset.cols = view === 'big' ? '2' : '4';
    updateProductCardImageSizes(view);
  }

  applyCollectionView(savedView);

  var collectionEl = sectionEl.querySelector('.collection');
  var btn = document.createElement('a');
  btn.type = 'button';
  btn.className = 'collection__view-toggle body-l-regular';
  var viewToggleLabel = sectionEl.dataset.viewToggleLabel || collectionEl?.dataset.viewToggleLabel || 'Cambiar vista';
  btn.setAttribute('aria-label', viewToggleLabel);
  btn.dataset.view = savedView;
  btn.innerHTML = '<span>' + viewToggleLabel + '</span>';

  btn.addEventListener('click', function () {
    var isBig = grid.classList.contains('collection__grid--big');
    var next = isBig ? 'small' : 'big';
    applyCollectionView(next);
    localStorage.setItem(storageKey, next);
    btn.dataset.view = next;
  });

  var facetsInner = sectionEl.querySelector('.collection-facets__inner');
  if (facetsInner) {
    facetsInner.appendChild(btn);
  }

  function repositionFeaturedCard() {
    var featuredCard = grid.querySelector('.collection__card--featured');
    if (featuredCard) {
      var nonFeatured = Array.from(grid.children).filter(function(el) {
        return el !== featuredCard;
      });
      var anchor = nonFeatured[3];
      if (anchor) {
        anchor.after(featuredCard);
      }
    }
  }
  repositionFeaturedCard();

  function hoistSizeModals() {
    sectionEl.querySelectorAll('.product-size-modal:not([data-hoisted]), .product-color-modal:not([data-hoisted])').forEach(function (modal) {
      modal.dataset.hoisted = '1';
      document.body.appendChild(modal);
    });
  }
  hoistSizeModals();

  function initDefaultColorSelection() {
    sectionEl.querySelectorAll('product-card:not([data-color-init])').forEach(function (card) {
      card.dataset.colorInit = '1';
      var colorFieldset = card.querySelector('.js-color-fieldset');
      if (!colorFieldset) return;
      var firstRadio = colorFieldset.querySelector('.variant-option-radio-input');
      if (!firstRadio) return;
      if (!firstRadio.checked) {
        colorFieldset.querySelectorAll('.variant-option-radio-input').forEach(function (r) {
          r.checked = false;
        });
        firstRadio.checked = true;
      }
      firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDefaultColorSelection);
  } else {
    initDefaultColorSelection();
  }

  function initCardSliders() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(initCardSliders, 250);
      return;
    }

    var sliderMedias = sectionEl.querySelectorAll('.product-card__media--slider:not([data-slider-init])');
    sliderMedias.forEach(function(media) {
      var imgs = Array.from(media.querySelectorAll('.slider-img'));
      if (imgs.length <= 1) return;

      var swiperEl = document.createElement('div');
      swiperEl.className = 'swiper product-card-swiper';

      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      imgs.forEach(function(img) {
        img.classList.remove('slider-img', 'slider-img--active');
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(img);
        wrapper.appendChild(slide);
      });

      var btnPrev = document.createElement('div');
      btnPrev.className = 'swiper-button-prev';
      var btnNext = document.createElement('div');
      btnNext.className = 'swiper-button-next';

      var pagination = document.createElement('div');
      pagination.className = 'swiper-pagination';
      pagination.style.setProperty('--product-card-pagination-total', imgs.length);
      pagination.style.setProperty('--product-card-pagination-index', 0);

      swiperEl.appendChild(wrapper);
      swiperEl.appendChild(btnPrev);
      swiperEl.appendChild(btnNext);
      swiperEl.appendChild(pagination);

      media.innerHTML = '';
      media.appendChild(swiperEl);

      var cardSwiper = new Swiper(swiperEl, {
        loop: true,
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          bulletClass: 'product-card-swiper__pagination-item',
          bulletActiveClass: 'product-card-swiper__pagination-item--active',
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
      });

      cardSwiper.on('slideChange', function () {
        pagination.style.setProperty('--product-card-pagination-index', cardSwiper.realIndex);
      });

      media.setAttribute('data-slider-init', '1');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSliders);
  } else {
    initCardSliders();
  }

  if (!Shopify.designMode) {
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('plp-card-revealed');
        cardObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -30px 0px', threshold: 0.05 });

    function observeGridCards() {
      var unrevealedCards = Array.from(grid.children).filter(function (card) {
        return !card.classList.contains('plp-card-revealed');
      });

      unrevealedCards.sort(function (a, b) {
        var aRect = a.getBoundingClientRect();
        var bRect = b.getBoundingClientRect();
        var rowTolerance = 8;

        if (Math.abs(aRect.top - bRect.top) > rowTolerance) {
          return aRect.top - bRect.top;
        }

        return aRect.left - bRect.left;
      });

      var currentRowTop = null;
      var colIndex = 0;
      unrevealedCards.forEach(function (card) {
        var cardTop = card.getBoundingClientRect().top;

        if (currentRowTop === null || Math.abs(cardTop - currentRowTop) > 8) {
          currentRowTop = cardTop;
          colIndex = 0;
        }

        card.style.transitionDelay = (colIndex * 0.08) + 's';
        colIndex++;
        cardObserver.observe(card);
      });
    }

    requestAnimationFrame(function () {
      observeGridCards();
    });

    var mutationDebounce;
    var gridContainer = sectionEl.querySelector('#ProductGridContainer') || grid.parentElement;
    var mutationObs = new MutationObserver(function () {
      clearTimeout(mutationDebounce);
      mutationDebounce = setTimeout(function () {
        mutationObs.disconnect();
        grid = sectionEl.querySelector('#product-grid') || grid;
        var currentView = localStorage.getItem(storageKey) || 'small';
        grid.classList.remove('collection__grid--big', 'collection__grid--small');
        grid.classList.add('collection__grid--' + currentView);
        grid.dataset.cols = currentView === 'big' ? '2' : '4';
        btn.dataset.view = currentView;
        updateProductCardImageSizes(currentView);
        repositionFeaturedCard();
        requestAnimationFrame(function () {
          observeGridCards();
          initCardSliders();
          hoistSizeModals();
          initDefaultColorSelection();
          mutationObs.observe(gridContainer, { childList: true, subtree: true });
        });
      }, 50);
    });
    mutationObs.observe(gridContainer, { childList: true, subtree: true });
  }

  // Abrir modal de colores
  var colorModalSourceCard = null;
  sectionEl.addEventListener('click', function (e) {
    if (window.innerWidth > 1023) return;
    var fieldset = e.target.closest('.js-color-fieldset[data-opens-color-modal]');
    if (!fieldset) return;
    e.preventDefault();
    e.stopPropagation();
    var modalId = fieldset.dataset.opensColorModal;
    var modal = document.getElementById(modalId);
    if (!modal) return;
    colorModalSourceCard = fieldset.closest('product-card');
    if (colorModalSourceCard) {
      var checkedRadio = colorModalSourceCard.querySelector('.js-color-fieldset .variant-option-radio-input:checked');
      var label = modal.querySelector('[data-color-modal-label]');
      if (checkedRadio && label) label.textContent = checkedRadio.value;
      if (checkedRadio) {
        var modalRadio = modal.querySelector('.variant-option-radio-input[value="' + checkedRadio.value.replace(/"/g, '\\"') + '"]');
        if (modalRadio) modalRadio.checked = true;
      }
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }, true);

  // Cerrar modal de colores
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-color-modal__close') ||
        e.target.classList.contains('product-color-modal__backdrop')) {
      var modal = e.target.closest('.product-color-modal');
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        colorModalSourceCard = null;
      }
    }
  });

  // Seleccionar color desde el modal: sincronizar con la card y cerrar
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product-color-modal .variant-option-radio-input')) return;
    var modal = e.target.closest('.product-color-modal');
    if (!modal) return;
    var colorValue = e.target.value;
    var label = modal.querySelector('[data-color-modal-label]');
    if (label) label.textContent = colorValue;
    if (colorModalSourceCard) {
      var cardRadio = colorModalSourceCard.querySelector('.js-color-fieldset .variant-option-radio-input[value="' + colorValue.replace(/"/g, '\\"') + '"]');
      if (cardRadio) {
        cardRadio.checked = true;
        var selectedDiv = cardRadio.closest('.button--variant');
        if (selectedDiv) {
          var fieldset = colorModalSourceCard.querySelector('.js-color-fieldset');
          if (fieldset) {
            var visibleDiv = fieldset.querySelector('.button--variant:not(.color-swatch-extra)');
            if (visibleDiv && visibleDiv !== selectedDiv) {
              visibleDiv.classList.add('small-hide', 'medium-hide', 'color-swatch-extra');
              selectedDiv.classList.remove('small-hide', 'medium-hide', 'color-swatch-extra');
            }
          }
        }
        cardRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    setTimeout(function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      colorModalSourceCard = null;
    }, 200);
  });

  // Actualizar hints del modal de tallas y pills de hover cuando cambia el color
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches('.js-color-fieldset .variant-option-radio-input')) return;
    var card = radio.closest('product-card');
    if (!card) return;
    if (!sectionEl.contains(card)) return;

    var newColor = radio.value;

    var sizesHover = card.querySelector('.product-card__sizes-hover');
    if (sizesHover) {
      sizesHover.querySelectorAll('.product-card__hover-size-item').forEach(function (item) {
        var colorStatesStr = item.dataset.colorStates;
        if (!colorStatesStr) return;
        var colorStates;
        try { colorStates = JSON.parse(colorStatesStr); } catch (err) { return; }
        var state = colorStates[newColor];
        item.classList.toggle('unavailable', !state || !state.a);
        item.classList.toggle('low-stock', !!(state && state.l));
      });
    }

    var openBtn = card.querySelector('.cta-add-resp[data-opens-modal]');
    if (!openBtn) return;
    var sizeModal = document.getElementById(openBtn.dataset.opensModal);
    if (!sizeModal) return;

    var sizesDiv = sizeModal.querySelector('.product-size-modal__sizes');
    if (!sizesDiv) return;
    var hintLowStock = sizesDiv.dataset.hintLowStock;
    var hintNotify = sizesDiv.dataset.hintNotify;

    sizesDiv.dataset.activeColor = newColor;

    sizesDiv.querySelectorAll('.product-size-modal__size-row').forEach(function (row) {
      var pill = row.querySelector('.product-card__size-pill');
      if (!pill) return;

      var colorStatesStr = row.dataset.colorStates;
      if (!colorStatesStr) return;
      var colorStates;
      try { colorStates = JSON.parse(colorStatesStr); } catch (err) { return; }

      var state = colorStates[newColor];

      row.querySelectorAll('.product-size-modal__size-hint').forEach(function (h) { h.remove(); });

      if (!state || !state.a) {
        row.classList.add('product-size-modal__size-row--unavailable');
        pill.classList.add('unavailable');
        var unavailableHint = document.createElement('span');
        unavailableHint.className = 'product-size-modal__size-hint body-s-regular underlined';
        unavailableHint.textContent = hintNotify;
        row.appendChild(unavailableHint);
      } else {
        row.classList.remove('product-size-modal__size-row--unavailable');
        pill.classList.remove('unavailable');
        if (state.l) {
          var lowStockHint = document.createElement('span');
          lowStockHint.className = 'product-size-modal__size-hint product-size-modal__size-hint--low body-s-regular';
          lowStockHint.textContent = hintLowStock;
          row.appendChild(lowStockHint);
        }
      }
    });
  });
}

// Auto-initialize all collection sections
document.querySelectorAll('.section-collection[id^="shopify-section-"]').forEach(initCollectionSection);

// ── Featured product video: only load and play once it enters the viewport ──
(function () {
  var videos = document.querySelectorAll('.js-lazy-video');
  if (!videos.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var video = entry.target;
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.play().catch(function () {});
      observer.unobserve(video);
    });
  }, { rootMargin: '200px' });

  videos.forEach(function (video) {
    observer.observe(video);
  });
}());
